// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Backslash = createIcon(
  <path
    clipRule="evenodd"
    d="M7.102 7.06828C7.45348 6.71681 8.02333 6.71683 8.37479 7.06831L16.9293 15.6233C17.2808 15.9748 17.2808 16.5446 16.9293 16.8961C16.5778 17.2475 16.008 17.2475 15.6565 16.896L7.10197 8.34107C6.7505 7.98959 6.75052 7.41974 7.102 7.06828Z"
    fillRule="evenodd"
  />,
);
